import React from 'react'
import { Box, Typography } from '@mui/material'

import { AppPillToggle } from '@components'
import { dsColorNew } from '@palette'
import { DateRangeField } from './DateRangeFilter'

/**
 * Comparison mode picker — None / Previous Year / Custom range.
 *
 *   value = { mode: 'none'|'py'|'custom', from?: 'YYYY-MM-DD', to?: 'YYYY-MM-DD' }
 *   onChange(value)
 */
/**
 * onChange(value, { intent }) where intent is:
 *   - 'instant'  → mode changed to None or PY; host applies now
 *   - 'pending'  → mode is Custom or user is picking the custom range
 */
const MODES = [
	{ value: 'none',   label: 'No comparison' },
	{ value: 'py',     label: 'Previous Year' },
	{ value: 'custom', label: 'Custom range' },
]

// The mode pills, for the top row of the filter band
export function ComparePills({ value, onChange }) {
	const { from, to } = value

	const setMode = (m) => {
		const next = {
			mode: m,
			from: m === 'custom' ? (from || '') : '',
			to:   m === 'custom' ? (to   || '') : '',
		}
		// Custom requires the operator to pick a range → not yet applyable.
		const intent = m === 'custom' ? 'pending' : 'instant'
		onChange(next, { intent })
	}

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
		<Typography component="span" sx={{ fontSize: 12.5, fontWeight: 500, color: dsColorNew.textMuted, whiteSpace: 'nowrap' }}>Compare vs</Typography>
		<AppPillToggle size="small" value={value.mode} options={MODES} onChange={setMode}/>
	</Box>
}

// The range to compare with, among the fields while the mode is Custom
export function CompareRangeField({ value, onChange }) {
	if (value.mode !== 'custom') return null
	return <DateRangeField label="Custom range"
	                       value={value}
	                       onChange={({ from, to }) => onChange({ mode: 'custom', from, to }, { intent: 'pending' })}/>
}

export default function ComparisonPicker({ value, onChange }) {
	return (
		<Box display="flex" gap={1.5} alignItems="center" flexWrap="wrap">
			<ComparePills value={value} onChange={onChange}/>
			{value.mode === 'custom' && <Box sx={{ minWidth: 240 }}><CompareRangeField value={value} onChange={onChange}/></Box>}
		</Box>
	)
}
